import React from 'react';

// Catches render/runtime errors in a dashboard subtree so one failed widget degrades to an inline
// message instead of white-screening the whole page.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('Dashboard section failed:', error, info?.componentStack);
    }

    render() {
        if (this.state.error) {
            const message = this.state.error?.response?.data?.message || this.state.error?.message || 'Something went wrong';
            return (
                <div className="alert alert-danger m-3" role="alert">
                    <strong>{this.props.title || 'This section'} could not be loaded.</strong> {message}
                    <button type="button" className="btn btn-sm btn-outline-danger ml-3" onClick={() => this.setState({ error: null })}>Retry</button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
